/**
 * @description 窗口尺寸监听Hook
 * @date 2025-01-17
 * @author lv.chen
 */

import { useState, useEffect } from 'react';

const LEFT_RIGHT_WIDTH = 1717;

interface IUseWindowResizeReturn {
  /** 是否超过右侧宽度阈值 */
  isOverRightWidth: boolean;
}

/**
 * 窗口尺寸监听Hook
 */
export default function useWindowResize(): IUseWindowResizeReturn {
  const [isOverRightWidth, setIsOverRightWidth] = useState(false);

  useEffect(() => {
    // 初始化设置
    setIsOverRightWidth(window.innerWidth > LEFT_RIGHT_WIDTH);

    /**
     * 窗口尺寸变化处理函数
     */
    const handleWindowResize = (): void => {
      setIsOverRightWidth(window.innerWidth > LEFT_RIGHT_WIDTH);
    };

    // 添加监听
    window.addEventListener('resize', handleWindowResize);

    // 清理监听
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return {
    isOverRightWidth,
  };
}
